import PropTypes from 'prop-types';
import React from 'react';

import {FiltersWrapper} from '@appComponents/HOCFiltersWrapper';
import {SearchFilter} from '@utils/commonFilters/SearchFilter';
import {CountriesFilter} from '@utils/commonFilters/CountriesFilter';

export const LicensorFiltersComponent = (props) => {
    const { countries } = props.data,
        loading = props.loading;

    return (
        <div className='content__filters'>
            <SearchFilter
                loading={loading}
                filters={props.filters.Licensors}
                restoreFilterValues={props.restoreFilterValues}
            />
            <CountriesFilter
                countries={countries}
                loading={loading}
                filters={props.filters.Licensors}
                restoreFilterValues={props.restoreFilterValues}
            />
        </div>
    );
};

LicensorFiltersComponent.propTypes = {
    data: PropTypes.shape({
        countries: PropTypes.array,
    }),
    filters: PropTypes.shape({
        Licensors: PropTypes.object,
    }),
    loading: PropTypes.bool,
    restoreFilterValues: PropTypes.func.isRequired,
};

LicensorFiltersComponent.defaultProps = {
    data: {
        countries: [],
    },
};

const LicensorFilters = FiltersWrapper(LicensorFiltersComponent, {name: 'Licensors'});

export default LicensorFilters;
